const Plus = ({ size, box, id }: { box: string; size: string; id: string }) => (
  <svg
    width={size}
    height={size}
    viewBox={`0 0 ${box} ${box}`}
    className="fill-current"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id={id}
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="1"
      y="1"
      width={size}
      height={size}
    >
      <path d="M9 2C9 1.44772 8.55229 1 8 1C7.44772 1 7 1.44772 7 2V7H2C1.44772 7 1 7.44772 1 8C1 8.55229 1.44772 9 2 9H7V14C7 14.5523 7.44772 15 8 15C8.55229 15 9 14.5523 9 14V9H14C14.5523 9 15 8.55229 15 8C15 7.44772 14.5523 7 14 7H9V2Z" />
    </mask>
    <g mask={`url(#${id})`}>
      <rect width={size} height={size} />
    </g>
  </svg>
)

export default Plus
